export default "__VITE_ASSET__BrJfb57R__"